<template>
  <div class="home">

  {{$teras.lang.inviatoText}} 


   <div class="row " style="margin-top:40px;">
    <div class="col s12 m3">&#160;</div>
    <div class="col s12 m6"><el-button type="primary" @click="onNew" style="width:100%;">{{$teras.lang.inviatoButton}} </el-button></div>
    <div class="col s12 m3"></div>
  </div>


  </div>
</template>

<script>

var moment = require('moment')

export default {
  name: 'inviato',
  data () {
    return {
      title:'',
      page: ''
    }
  },
  created(){
    var parent = this

    /*
    this.axios.get('page/home.html',{responseType: 'document'})
    .then(function (response) {
      parent.page = response.request.response.body.children.item(1).innerHTML
      
    })
    */
  },
  mounted(){
    
  },
  methods: {
    onNew(){
      this.$teras.appReady = false
      this.$abs.nuovo().then(() => {
        if(moment(this.$teras.evento.deadline).isAfter(moment())){
          this.$teras.preview = false
          this.$teras.absInviato = false
          this.$router.push('/abs-new')
        }else{
          this.$teras.chiuso=true
          this.$router.push('/')
        }
        this.$teras.appReady = true
      })
    }
  }
}
</script>


<style scoped>
.combustion div.el-carousel__container {
  height: 440px !important;
  border:10px solid red;
  width: 500px;
}
.home a.btn{
  display:block;
  width: 100%;
  height: 3.8rem;
  color:#ffffff;
  text-align: center;
  line-height: 3.8rem;
  font-size: 1.8rem;
  font-weight: bold;
  background: darkred;
  border-color: darkred;
}.home a.main{
  display:block;
  font-size:2.3rem;
  text-align: center;
  color:darkred;
  font-weight: bold;
  padding:20px 0;
}
</style>



// WEBPACK FOOTER //
// Inviato.vue?34dec864